import { ButtonMantine, Flex, Modal, ModalProps, Stack, Text, Title } from 'ui';

type UnfollowModalProps = ModalProps & {
  causeName: string;
  onUnfollow: () => void;
  onCancel?: () => void;
  loading: boolean;
};

const UnfollowModal = ({
  opened,
  onClose,
  causeName,
  onUnfollow,
  loading,
  onCancel,
  ...props
}: UnfollowModalProps) => {
  return (
    <Modal title="Unfollow" opened={opened} onClose={onClose} {...props}>
      <Stack gap="lg">
        <Stack gap="xs">
          <Title order={4}>Are you sure you want to unfollow {causeName}?</Title>
          <Text fz="sm" c="gray">
            If you unfollow {causeName}, they will be removed from your homepage, making them harder
            to find later.
          </Text>
        </Stack>
        <Flex justify="space-between" direction="row-reverse">
          <Flex gap="md" direction="row-reverse">
            <ButtonMantine
              color="cerise"
              miw={160}
              size="md"
              onClick={onUnfollow}
              loading={loading}
            >
              Unfollow
            </ButtonMantine>
            <ButtonMantine size="md" variant="subtle" onClick={onCancel ?? onClose}>
              Cancel
            </ButtonMantine>
          </Flex>
        </Flex>
      </Stack>
    </Modal>
  );
};

export { UnfollowModal };
